export const UPDATE_SOURCE_REQUEST = 'UPDATE_SOURCE_REQUEST'
export const UPDATE_SOURCE_FAIL = 'UPDATE_SOURCE_FAIL'
export const UPDATE_SOURCE_SUCCESS = 'UPDATE_SOURCE_SUCCESS'